import React from "react";
import { QRCodeCanvas } from "qrcode.react";

const QRCodeGenerator = ({ value, size = 256, level = "H" }) => {
  return (
    <QRCodeCanvas value={value} size={size} level={level} />
  );
};

export default QRCodeGenerator;
